import { Component, Input, OnInit } from '@angular/core';
import { CompanyType } from 'src/app/settings/constants';
import { ReceiversService } from 'src/app/shared/services/receivers.service';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
  selector: 'app-receivers-list-component',
  templateUrl: './receivers-list-component.html',
  styleUrls: ['./receivers-list-component.scss'],
})
export class ReceiversListComponent implements OnInit {
  @Input() company: CompanyType;

  displayedColumns: string[] = ['name', 'apiKey', 'ip', 'monitoringPort', 'receiverEventPort', 'snifferPort'];
  dataSource: any[];

  show = false;

  constructor(private receiversService: ReceiversService, private authService: AuthService) {}

  ngOnInit(): void {
    this.dataSource = this.company.receivers;
  }

  isLast(item: any, array: string | any[]) {
    return array[array.length - 1] === item;
  }

  roleAllowed() {
    return this.authService.hasRolesAdminOrDistributor();
  }

  convertToName(ip: string) {
    if (!this.roleAllowed()) {
      return '********';
    }

    const serverLocation = this.receiversService.receiverServers.find((location) => location.ip === ip);

    if (!serverLocation) {
      return '-';
    }

    return `${serverLocation.name} - ${serverLocation.location}`;
  }
}
